import EventListSkeleton from './EventListSkeleton';

export default EventListSkeleton;
